export const UPLOAD_INLINE_IMAGE_REQUEST = 'UPLOAD_INLINE_IMAGE_REQUEST';

export const uploadInlineImage = ({ file, callback }) => ({
    type: UPLOAD_INLINE_IMAGE_REQUEST,
    payload: { file, callback }
});
